import { render } from "./UserPlaylists.vue?vue&type=template&id=9dcffb0e&scoped=true"
import script from "./UserPlaylists.vue?vue&type=script&lang=js"
export * from "./UserPlaylists.vue?vue&type=script&lang=js"

import "./UserPlaylists.vue?vue&type=style&index=0&id=9dcffb0e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dcffb0e"]])

export default __exports__